import { createContext } from "react";

export const MarketplaceGlobalDataContext = createContext({
    marketplaceNetworks: {},
    domainToCustomerMappings: {},
    domainToNetworkMappings: {},
    allOrders: []
})